import { TFunction } from 'i18next';

// Agent configuration using kit names as translation keys
export const agentIds = {
  PLAN_DOCUMENT_AGENT: 'planexecution.assistant.plan_document_agent',
  PAYOUTS_INFO_AGENT: 'payouts.assistant.payouts_info_agent',
  MODELING_AGENT: 'worksheets.modeling_agent',
  CATALYST_ML_TRAINING_AGENT: 'catalyst.ml.training_run_explainer',
  CATALYST_ML_PREDICTION_AGENT: 'catalyst.ml.prediction_explainer',
  INQUIRIES_AGENT: 'disputes.inquiries',
  PAYEE_AGENT: 'payee.assistant.payee_agent',
  TRANSFORMATION_AGENT: 'worksheets.kits.transformation',
  ACCOUNT_DEALER_AGENT: 'tq.account_dealer',
  CATALYST_EPM_AGENT: 'catalyst.epm.agent',
  AUDIT_LOGS_AGENT: 'audit.assistkit.audit_logs_agent',
} as const;

export type AgentName = (typeof agentIds)[keyof typeof agentIds];

// Helper function to get agent config from translations
export const getAgentConfig = (identifier: string, t?: TFunction) => {
  if (!t) {
    // Fallback for non-React contexts
    return {
      name: identifier,
      short_description: 'AI Assistant',
      medium_description: 'AI Assistant',
      prompts: [],
    };
  }

  // Get prompts with fallback to empty array
  const promptsResult = t(`agents.${identifier}.prompts`, { returnObjects: true });
  const prompts = Array.isArray(promptsResult) ? promptsResult : [];

  // Check if translation exists, if not use identifier as fallback
  const name = t(`agents.${identifier}.name`);
  const fallbackName = name.includes('agents.') ? identifier : name;

  return {
    name: fallbackName,
    short_description: t(`agents.${identifier}.short_description`),
    medium_description: t(`agents.${identifier}.medium_description`),
    prompts,
  };
};
